
const digest = '0728245d4a92ca06cc55cb008af76d522419af55397fb763101a05bafa5d3fc3';
const classes = {"wrapper":"_wrapper_1jj8w_1","badge":"_badge_1jj8w_14"};
const css = `._wrapper_1jj8w_1 {
  position: relative;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_1jj8w_1 img {
  height: 14px;
}
._wrapper_1jj8w_1 ._badge_1jj8w_14 {
  position: absolute;
  background-color: #F12948;
  height: 12px;
  width: 12px;
  border-radius: 100%;
  top: -3px;
  right: -3px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  